/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { theme } from "@nordcloud/gnui";
import { Badge } from "~/components/Badge/Badge";

export function displayLevel(type?: string) {
  switch (type) {
    case "gold":
      return <Badge color="#f9ad0e" text="GOLD" />;
    case "silver":
      return <Badge color="#a9a9a9" text="SILVER" />;
    case "bronze":
      return <Badge color="#a75d03" text="BRONZE" />;
    case "platinum":
      return <Badge color="#7b7b92" text="PLATINUM" />;
    case "unspecified":
      return <Badge color="#009a00" text="UNSPECIFIED" />;
    default:
      return <Badge color={theme.color.text.text01} text="UNDEFINED" />;
  }
}
